import React, { useState } from "react";
import { Layout, Menu, Breadcrumb, Card } from "antd";
import { TeamOutlined, FileTextOutlined ,UserOutlined,LogoutOutlined} from "@ant-design/icons";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
 
const { Header, Sider, Content } = Layout;
 
const AdminDashboardLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {key:"/admin/dashboard/Manage-Customers",icon:<UserOutlined/>,label:"Manage Customers"},
    { key: "/admin/dashboard/Seller-details", icon: <UserOutlined />, label: "Manage Sellers"},
    { key: "/admin/dashboard/manage-categories", icon: <FileTextOutlined />, label: "Manage Categories" }, 
    { key: "/admin/dashboard/pending-sellers", icon: <TeamOutlined />, label: "Pending Sellers" },
    { key: "/admin/dashboard/approved-sellers", icon: <TeamOutlined />, label: "Approved Sellers" },
    { key: "/admin/dashboard/rejected-sellers", icon: <TeamOutlined />, label: "Rejected Sellers" },
     { key: "/admin/dashboard/user-queries", icon: <FileTextOutlined />, label: "User Queries" }, 
    { key: "/admin/dashboard/logout", icon: <LogoutOutlined />, label: "Logout" },
  ];

  const selectedKey = menuItems.find(item => location.pathname.startsWith(item.key))?.key || "";


  return (
<Layout style={{ minHeight: "100vh" }}>
      {/* Sidebar */}
<Sider
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
        width={230}
        style={{
          background: "#1129ce", // ✅ Bright blue like screenshot
          boxShadow: "2px 0 8px rgba(0, 0, 0, 0.15)",
        }}
>
<div
          style={{
            color: "white",
            padding: "20px 16px",
            fontSize: collapsed ? "16px" : "20px",
            textAlign: "center",
            fontWeight: "bold",
            borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
          }}
>
          Admin Panel
</div>
 
        {/* Menu */}
<Menu
          mode="inline"
          selectedKeys={selectedKey ? [selectedKey] : []}
          onClick={(item) => navigate(item.key)}
          items={menuItems}
          style={{
            background: "#1129ce",
            color: "white",
            paddingTop: "10px",
            fontSize: "15px",
          }}
          theme="dark"
        />
</Sider>
 
      {/* Custom CSS for selected menu item */}
<style>
        {`
          .ant-menu-dark .ant-menu-item-selected {
            background-color: #1129ce!important; /* Darker blue for active tab */
            border-radius: 6px;
          }
          .ant-menu-dark .ant-menu-item:hover {
            background-color: #1129ce!important; /* Match hover to selected */
          }
        `}
</style>
 
      {/* Main Layout */}
<Layout>
<Header style={{ background: "#fff", padding: "0 20px" }}>
<Breadcrumb style={{ margin: "16px 0" }}>
<Breadcrumb.Item>Home</Breadcrumb.Item>
<Breadcrumb.Item>
              {location.pathname.split("/")[2] || "Dashboard"}
</Breadcrumb.Item>
</Breadcrumb>
</Header>
 
        <Content style={{ margin: "16px", padding: "16px" }}>
<Card
            style={{
              minHeight: "75vh",
              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              background: "#fff",
            }}
>
            {location.pathname === "/admindashboard" ? (
<div
                style={{
                  textAlign: "center",
                  marginTop: "50px",
                  fontSize: "18px",
                  color: "#555",          }}
>
                Select an option from the sidebar
</div>
            ) : (
<Outlet />
            )}
</Card>
</Content>
</Layout>
</Layout>
  );
};
 
export default AdminDashboardLayout;